<div class="smartbook-content content-container">
  @if (showStickyHeader()) {
    <tt-sticky-header
      [isPublicPage]="isPublicPage()"
      [organisationImage]="organisationImage()"
      [showContentChangedBanner]="guidelineReviewPageService?.vm().isContentChangedDuringReview"
      [showContentEditingBanner]="guidelineReviewPageService?.vm().isContentEditing"
      [title]="guidelineData().title" />
  }

  @if ((guidelineViewService.isPreviewMode() || guidelineViewService.isReviewMode()) && disabled()) {
    @if (!refreshGuidelineButtonEnabled()) {
      <tt-banner class="smartbook-content_banner" [message]="'GuidelineEditor.Concurrency.OtherUserEditingBanner' | transloco" />
    } @else {
      <tt-banner
        class="smartbook-content_banner"
        [message]="'GuidelineEditor.Concurrency.OtherUsersFinishedEditingBanner' | transloco"
        [type]="'info'" />
    }
  }

  <div class="smartbook-content_top">
    @if (guidelineData()?.taxonomies?.length) {
      <tt-taxonomy-breadcrumb [taxonomies]="guidelineData().taxonomies" />
    } @else {
      <div class="smartbook-content_top-spacer"></div>
    }

    <tt-currently-edited-by (reload)="reloadGuideline.emit()" />
  </div>

  <tt-smartbook-header
    inViewport
    [guidelineData]="guidelineData()"
    [isPreviewMode]="isPreviewMode()"
    [isPublicPage]="isPublicPage()"
    [isRevisionDateEnabled]="isRevisionDateEnabled()"
    [organisationImage]="organisationImage()"
    [showContentChangedBanner]="guidelineReviewPageService?.vm().isContentChangedDuringReview"
    [showContentEditingBanner]="guidelineReviewPageService?.vm().isContentEditing"
    [soonToExpirePeriod]="soonToExpirePeriod()"
    (triggerUpdateDialog)="showUpdateDialog()"
    (visible)="isHeaderVisible.set($event)" />

  @if (allResourceTags()?.length) {
    <div class="smartbook-content_tags">
      <h5 class="smartbook-content_tags-header">{{ 'GuidelineEditor.ResourceTags.TagsUsedInGuideline' | transloco }}:</h5>
      <tt-resource-tag-list [readonly]="true" [tags]="allResourceTags()" />
    </div>
  }

  <tt-chapter-widget-list [chapterIds]="chapters() | mapToUniqueId" />

  @if (orderedReferencesWithNumber(); as orderedReferences) {
    @if (orderedReferences.length > 0 && !isTeaserMode()) {
      <div class="smartbook-content_references" data-userguide="smartbook-content_references">
        <div class="smartbook-content_references-title">{{ 'References' | transloco }}:</div>
        <tt-reference-list [references]="orderedReferences" />
      </div>
    }
  }
  @if (isPublicPage()) {
    <div class="smartbook-content_disclaimer">
      <h5 class="smartbook-content_disclaimer-header">{{ 'DisclaimerTextTitle' | transloco }}</h5>
      <p class="smartbook-content_disclaimer-text">{{ 'DisclaimerText' | transloco }}</p>
    </div>
  }
</div>
